<template>
  <v-list>
    <v-list-item
      v-for="excerpt in excerpts"
      :key="excerpt.id"
      @click="selectExcerpt(excerpt.id)"
      class="px-0"
    >
      <resource-card
        :ref="excerpt.id"
        :flat="true"
        :disableHoverShadow="true"
        color="transparent"
        class="pa-4"
        :blockData="{ excerpts: [excerpt], resource: resource }"
        blockType="excerpt"
        style="width: 100%;"
      >
        <template v-slot:after>
          <slot v-bind:excerpt="excerpt" v-bind:selected="selectedExcerpt == excerpt.id"></slot>
        </template>
      </resource-card>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapActions } from 'vuex';
import ResourceCard from '@/components/Resources/ResourceCard';
export default {
  props: ['resource', 'userCanEdit'],
  components: { ResourceCard },
  data() {
    return {
      selectedExcerpt: null
    };
  },
  computed: {
    excerpts() {
      let result;
      try {
        const resourceType = this.resource.resourceData.type;
        if (resourceType == 'webpage' || resourceType == 'pdf') {
          //  TRYING TO SORT FIRST BY POSITION, THEN BY DATE IF NO POSITION
          let positionExcerpts = [];
          let dateExcerpts = [];
          const types = ['textExcerpt', 'imageExcerpt'];
          Object.values(this.resource.noteBlocks).forEach(n => {
            if (n.toDelete || n.type != 'widget' || !types.includes(n.content.widgetType)) {
              return;
            } else {
              if (
                n.content.widgetData.order ||
                (n.content.widgetData.positions && n.content.widgetData.positions[0])
              ) {
                positionExcerpts.push(n);
              } else {
                dateExcerpts.push(n);
              }
            }
          });
          console.log(positionExcerpts, dateExcerpts);
          positionExcerpts = positionExcerpts.sort((a, b) => {
            if (resourceType == 'webpage') {
              return a.content.widgetData.order < b.content.widgetData.order ? -1 : 1;
            } else if (resourceType == 'pdf') {
              return a.content.widgetData.pages[0] + a.content.widgetData.positions[0].y >
                b.content.widgetData.pages[0] + b.content.widgetData.positions[0].y
                ? 1
                : -1;
            }
          });
          dateExcerpts = dateExcerpts.sort((a, b) => {
            const aDate =
              typeof a.createdOn.toDate == 'function' ? a.createdOn.toDate() : a.createdOn;
            const bDate =
              typeof b.createdOn.toDate == 'function' ? b.createdOn.toDate() : b.createdOn;
            return aDate < bDate ? -1 : 1;
          });

          //  Now merge the date excerpts into the position excerpts by date
          let excerpts = [];
          positionExcerpts.forEach(e => {
            //  Do this because when it's first added it's not a datetime object

            const dateExcerpt = dateExcerpts[0];
            if (!dateExcerpt) {
              excerpts.push(e);
              return;
            }
            const dateExDate =
              typeof dateExcerpt.createdOn.toDate == 'function'
                ? dateExcerpt.createdOn.toDate()
                : e.createdOn;
            const exDate =
              typeof e.createdOn.toDate == 'function' ? e.createdOn.toDate() : e.createdOn;
            if (exDate > dateExDate) {
              // we shoudl insert the dateEx before the excerpt
              excerpts.push(dateExcerpt);
              excerpts.push(e);
              //  and remove that excpert from date excerpts
              dateExcerpts = dateExcerpts.slice(1);
            } else {
              excerpts.push(e);
            }
          });
          //  check if there are any left of date excerpts;
          if (dateExcerpts.length) {
            excerpts = excerpts.concat(dateExcerpts);
          }
          result = excerpts;
        } else {
          return [];
        }
        // else if (resourceType == 'pdf') {
        //   result = Object.values(this.resource.noteBlocks)
        //     .filter(e => !e.toDelete)
        //     .sort((a, b) => {
        //       if (a.content.widgetData.positions) {
        //         return a.content.widgetData.pages[0] + a.content.widgetData.positions[0].y >
        //           b.content.widgetData.pages[0] + b.content.widgetData.positions[0].y
        //           ? 1
        //           : -1;
        //       } else {
        //         const aDate =
        //           typeof a.createdOn.toDate == 'function' ? a.createdOn.toDate() : a.createdOn;
        //         const bDate =
        //           typeof b.createdOn.toDate == 'function' ? b.createdOn.toDate() : b.createdOn;
        //         return aDate < bDate ? -1 : 1;
        //       }
        //     });
        // }
      } catch (e) {
        console.log(e);
        result = [];
      }
      return result;
    }
  },
  methods: {
    ...mapActions('resources', ['deleteResourceNoteBlock']),
    selectExcerpt(id) {
      this.$emit('scrollTo', id);
      this.$emit('select', id);
      if (this.selectedExcerpt == id) {
        this.selectedExcerpt = null;
      } else {
        this.selectedExcerpt = id;
      }
    },
    // deleteExcerpt(id) {
    //   this.deleteResourceNoteBlock({ noteBlockId: id, resourceId: this.resource.id });
    //   this.$emit('removedExcerpt', id);
    // },
    scrollTo(id) {
      console.log(this.$refs[id][0]);
      this.selectedExcerpt = id;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$vuetify.goTo(this.$refs[id][0].$el, { container: '.resourceExcerptsPopover' });
        }, 100);
      });
    }
  }
};
</script>

<style></style>
